var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap",class:{
    'wrap-accept': _vm.isAccept,
    'wrap-error': _vm.isError,
    'wrap-green': _vm.isGreen
  }},[(_vm.text)?_c('texts',{class:{
      'wrap-folded': _vm.isFolded
    },attrs:{"text":_vm.text,"color":_vm.useColor,"size":"min"}}):_vm._e(),(!_vm.text)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }